import { defineGlobals } from "vue-utils"
import { ConfigService } from "./config"
import { DataService } from "./data"
import { DownloadsService } from "./downloads"
import { IncidentsService } from "./incidents"
import { UsersService } from "./users"
import { VtsService } from "./vts"
import { WeatherService } from "./weather"

const Api = {
	config: new ConfigService(),
	data: new DataService(),
	incidents: new IncidentsService(),
	users: new UsersService(),
	weather: new WeatherService(),
	downloads: new DownloadsService(),
	vts: new VtsService(),
}

defineGlobals({ Api })

export default Api
